module.exports = __webpack_public_path__ + "static/media/Niveau_elN1_2_9999.afe9dc9d.png";